import { TradeActivitySubTrade, TradeDetailState } from './reducer'

type State = { tradeDetail: TradeDetailState }

export const getTradeOverview = (state: State) => state.tradeDetail.overview

export const getTradeDetailDeals = (state: State) => state.tradeDetail.lookups.deals
export const getTradeDetailFacilities = (state: State) => state.tradeDetail.lookups.facilities
export const getTradeDetailEntities = (state: State) => state.tradeDetail.lookups.entities
export const getTradeDetailEntityTypes = (state: State) => state.tradeDetail.lookups.entityTypes
export const getTradeDetailWireInstructions = (state: State) =>
  state.tradeDetail.lookups.wireInstructions
export const getTradeDetailFullySignedAa = (state: State) =>
  state.tradeDetail.lookups.fullySignedAaMetadata
export const getTradeDetailAaMetadata = (state: State) => state.tradeDetail.lookups.aaMetadata
/** The header's warnings as the Sub-trade read computed them, with the trade they are for. */
export const getTradeDetailHeader = (state: State) =>
  state.tradeDetail.lookups.header
    ? { masterTradeId: state.tradeDetail.lookups.masterTradeId, ...state.tradeDetail.lookups.header }
    : null

const NO_SUB_TRADES: TradeActivitySubTrade[] = []

/**
 * The Activity tab's sub trades for the note composer's picker (LOS-7095), from its own read —
 * only while that read is for this trade, so another trade's never show.
 */
export const getTradeActivitySubTrades = (state: State, masterTradeId: string | undefined) => {
  const overview = state.tradeDetail.overview
  return overview && overview.masterTradeId === masterTradeId && overview.subTrades
    ? overview.subTrades
    : NO_SUB_TRADES
}
